import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthUtils} from '../../../utils/AuthUtils';
import {PermissionTargetEnum} from '../../../enums/PermissionTargetEnum';
import {HttpEventType} from '@angular/common/http';
import {Globals} from '../../../global/globals';
import {SelectItem} from '../../../dtos/SelectItem';
import {FirmwareService} from '../../../services/rest/firmware.service';
import {ModuleTypeService} from '../../../services/rest/module-type.service';
import {ChipTypeService} from '../../../services/rest/chip-type.service';
import {DisplayTypeService} from '../../../services/rest/display-type.service';

@Component({
  selector: 'app-firmware-create',
  templateUrl: './firmware-create.component.html',
  styleUrls: ['./firmware-create.component.scss']
})
export class FirmwareCreateComponent {
  userCanEdit: boolean = AuthUtils.canEdit(PermissionTargetEnum.FIRMWARE);

  softwareTypeOptions: SelectItem[] = [
    { id: 'INTERNAL', name: 'INTERNAL', description: '' },
    { id: 'INTEGRATION', name: 'INTEGRATION', description: '' },
    { id: 'PRODUCTION', name: 'PRODUCTION', description: '' },
    { id: 'BOOTLOADER', name: 'BOOTLOADER', description: '' },
    { id: 'PARTITIONS', name: 'PARTITIONS', description: '' },
    { id: 'OTA_DATA', name: 'OTA_DATA', description: '' }
  ];

  moduleTypeOptions: SelectItem[] = [];
  chipTypeOptions: SelectItem[] = [];
  displayTypeOptions: SelectItem[] = [];

  form: FormGroup;
  progress: number | null = null;
  error: string | null = null;

  constructor(private service: FirmwareService,
              private moduleTypeService: ModuleTypeService,
              private chipTypeService: ChipTypeService,
              private displayTypeService: DisplayTypeService,
              private router: Router,
              private globals: Globals,
              private fb: FormBuilder) {
    this.moduleTypeService.getAll().subscribe(options => {
      this.moduleTypeOptions = options.map(m => ({
        id: m.code as any,
        name: m.name,
        description: m.code
      }));
    });
    this.chipTypeService.getAll().subscribe(options => {
      this.chipTypeOptions = options.map(c => ({
        id: c.code as any,
        name: c.name,
        description: c.code
      }));
    });
    this.displayTypeService.getAll().subscribe(options => {
      this.displayTypeOptions = options.map(d => ({
        id: d.code as any,
        name: d.name,
        description: d.code
      }));
    });
    this.form = this.fb.group({
      softwareType: ['', Validators.required],
      moduleTypeCode: ['', Validators.required],
      chipTypeCode: ['', Validators.required],
      displayTypeCode: ['', Validators.required],
      version: [{value: 0, disabled: true}],
      isInitializer: [false],
      file: [null, Validators.required]
    });

    this.form.get('isInitializer')?.valueChanges.subscribe(val => {
      if (val) {
        this.form.get('version')?.setValue(-1);
      } else {
        this.form.get('version')?.setValue(0);
      }
    });
  }

  onFileSelected(event: any) {
    const f = (event.target?.files && event.target.files.length) ? event.target.files[0] : null;
    this.form.patchValue({ file: f });
  }

  save() {
    if (!this.userCanEdit) return;
    if (!this.form || this.form.invalid) {
      this.form?.markAllAsTouched();
      this.error = 'Bitte Modul und Datei wählen';
      return;
    }
    this.progress = 0;
    this.error = null;

    const softwareType = this.form.value.softwareType as string;
    const moduleTypeCode = this.form.value.moduleTypeCode as string;
    const chipTypeCode = this.form.value.chipTypeCode as string;
    const displayTypeCode = this.form.value.displayTypeCode as string;
    const isInitializer = this.form.value.isInitializer as boolean;
    const file = this.form.value.file as File;

    this.service.upload(file, softwareType, moduleTypeCode, chipTypeCode, displayTypeCode, isInitializer).subscribe({
      next: ev => {
        if (ev.type === HttpEventType.UploadProgress) {
          if (ev.total) this.progress = Math.round(100 * ev.loaded / ev.total);
        }
      },
      error: err => {
        this.error = (err?.error && err.error.message) ? err.error.message : (err?.error || 'Fehler beim Upload');
        this.progress = null;
      },
      complete: () => this.router.navigate(['firmware'])
    });
  }
}
